import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Button } from '../../../iba-components/Button'
import { Input } from '../../../iba-components/Input'
import { Modal } from '../../../iba-components/Modal'
import { showPopBanner } from '../../../iba-components/PopBanner'
import LoadingMask from '../../components/LoadingMask'
import { stopAllClient, activeAllClient } from '../../api/allServiceStopV2'
import styles from './index.module.css'

const STOP_SERVICE = 'サービス緊急停止'
const STOP = 'stop'
const ACTIVE = 'active'

const success = (msg) =>
    showPopBanner({
        message: msg,
        status: 'success',
        duration: 3000
    })

const error = (msg) =>
    showPopBanner({
        message: msg,
        status: 'error',
        duration: 3000
    })

class AllServiceStopComponent extends Component {
    constructor() {
        super()
        this.state = {
            mode: '',
            text: '',
            visible: false,
            loading: false,
            errMsg: ''
        }
    }

    action = async () => {
        const { t, userInfo } = this.props
        if (this.state.mode === ACTIVE) {
            // to stop
            if (this.state.text !== STOP_SERVICE) {
                return this.setState({
                    errMsg: this.props.t('allServiceStop.confirmMsgError')
                })
            }
            this.setState({
                errMsg: '',
                loading: true
            })
            try {
                const { hasError, desc } = await stopAllClient({
                    createby: userInfo?.userinfo?.username
                })
                if (hasError) {
                    error(desc || t('allServiceStop.errorMsg'))
                } else {
                    success(t('allServiceStop.successMsg'))
                    this.close()
                }
            } catch (e) {
                error(t('allServiceStop.errorMsg'))
            } finally {
                this.setState({
                    loading: false
                })
            }
        }
        if (this.state.mode === STOP) {
            // to active
            this.setState({
                errMsg: '',
                loading: true
            })
            try {
                const { hasError, desc } = await activeAllClient({
                    createby: userInfo?.userinfo?.username
                })
                if (hasError) {
                    error(desc || t('allServiceStop.errorMsg'))
                } else {
                    success(t('allServiceStop.successMsg'))
                    this.close()
                }
            } catch (e) {
                error(t('allServiceStop.errorMsg'))
            } finally {
                this.setState({
                    loading: false
                })
            }
        }
    }

    close = () => {
        this.setState({
            visible: false,
            text: ''
        })
    }

    footer = (t) => {
        return (
            <div className={styles.footer}>
                <Button width="82px" label={t('allServiceStop.cancelText')} onClick={this.close} />
                <Button width="68px" label={t('allServiceStop.okText')} onClick={this.action} />
            </div>
        )
    }

    render() {
        const { t } = this.props
        return (
            <>
                {this.state.loading && <LoadingMask />}
                <div className={styles.button_area}>
                    <Button
                        width="180px"
                        label={t('allServiceStop.title')}
                        onClick={() => this.setState({ visible: true, mode: ACTIVE })}
                    />
                    <Button
                        width="152px"
                        label={t('allServiceStop.restart')}
                        onClick={() => this.setState({ visible: true, mode: STOP })}
                    />
                </div>
                {this.state.visible && (
                    <Modal
                        visible={this.state.visible}
                        placement="top"
                        width={500}
                        title={this.state.mode === ACTIVE ? t('allServiceStop.title') : t('allServiceStop.restart')}
                        onCancel={this.close}
                        footer={this.footer(t)}
                    >
                        {this.state.mode === ACTIVE ? (
                            <div>
                                <p style={{ marginBottom: 0 }}>{t('allServiceStop.warnMsg')}</p>
                                <p
                                    className="mb-20"
                                    style={{
                                        color: 'red',
                                        userSelect: 'none'
                                    }}
                                >
                                    {t('allServiceStop.confirmMsg')}
                                </p>
                                <Input
                                    width={460}
                                    value={this.state.text}
                                    onChange={(text) => this.setState({ text })}
                                    errorMsg={this.state.errMsg ? this.state.errMsg : ''}
                                />
                            </div>
                        ) : (
                            <div>
                                <p className="mb-20">{t('allServiceStop.restartMsg')}</p>
                            </div>
                        )}
                    </Modal>
                )}
            </>
        )
    }
}

export const AllServiceStop = connect((state) => ({
    userInfo: state.userInfo
}))(withTranslation()(AllServiceStopComponent))
